export enum AuthenticationStatus {
  AUTH_IN_PROGRESS,
  AUTHENTICATED,
  ERROR,
  LOGOUT,
  LOGGING_OUT
}

export interface AuthState {
  refreshToken: string | null | undefined
  accessToken: string | null | undefined
  idToken: Record<string, unknown> | null | undefined
  expiresEpochMs: number
  status: AuthenticationStatus
}
